import { z } from "zod";

export const MAX_CREDENTIAL_AUTO_PAUSE_REJECTED_RUNS = 100;
export const DEFAULT_CREDENTIAL_AUTO_PAUSE_REJECTED_RUNS = 3;

/** Null disables automatic pausing; a number opts into pausing after that many rejected runs. */
export const credentialAutoPauseThresholdSchema = z
  .number()
  .int()
  .min(1)
  .max(MAX_CREDENTIAL_AUTO_PAUSE_REJECTED_RUNS)
  .nullable();

export type CredentialAutoPauseThreshold = z.infer<
  typeof credentialAutoPauseThresholdSchema
>;
